import { render } from "./SafeIcon.vue?vue&type=template&id=bc0928d6&scoped=true"
import script from "./SafeIcon.vue?vue&type=script&lang=js"
export * from "./SafeIcon.vue?vue&type=script&lang=js"

import "./SafeIcon.vue?vue&type=style&index=0&id=bc0928d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc0928d6"]])

export default __exports__